exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".goBackButtonBox[data-v-0c543f56]{display:inline-block}.goBackButton[data-v-0c543f56]{border-radius:0;border-color:transparent;margin:0;padding:20px;background-color:transparent}.goBackIcon[data-v-0c543f56]{font-size:25px}[data-theme=light] .goBackIcon[data-v-0c543f56]{color:#6b6b6b!important}[data-theme=dark] .goBackIcon[data-v-0c543f56]{color:#d2d2d2!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c543f56","scoped":true,"hasInlineConfig":false}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/goBackButton/goBackButton.vue
// module id = 312
// module chunks = 0